var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"subject-dialog"},[_c('div',{staticClass:"action close",on:{"click":function($event){return _vm.onCloseButtonClick()}}},[_c('v-icon',[_vm._v("cancel")])],1),_c('v-card-text',[_c('TempSubject',{staticClass:"subject-dialog__subject",attrs:{"subjectParam":_vm.subject}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }